class PackageBuilder extends HTMLElement {
  constructor() {
    super();

    this.currentStep = 1;
    this.packageData = {
      productHandle: null,
      weeklyMenu: null,
      deliveryDate: null
    };
    this.quantities = {
      mains: {},
      sides: {},
      extras: {},
      addons: {}
    };
    this.mainsMax = 0;
    this.mainsAllowDuplicates = false;
    this.sidesMax = 0;
    this.sidesAllowDuplicates = false;
    this.product = null;
    this.weeklyMenus = null;
    this.bundle = null;
    this.skipWeeklyMenuValidation = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('.package-builder__open-button')) {
        event.preventDefault();
        const button = event.target.closest('.package-builder__open-button');
        const productHandle = button.dataset.productHandle;
        this.open(productHandle);
      }
    });

    // Weekly menu dropdown change
    const weeklyMenuSelect = this.querySelector('#weekly-menu-select');
    if (weeklyMenuSelect) {
      weeklyMenuSelect.addEventListener('change', this.onWeeklyMenuChange.bind(this));
    }

    // Next button click
    const nextButton = this.querySelector('.package-builder__next-button');
    if (nextButton) {
      nextButton.addEventListener('click', this.onNextButtonClick.bind(this));
    }

    // Close button click
    const closeButton = this.querySelector('.package-builder__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    // Back button clicks
    this.addEventListener('click', (event) => {
      if (event.target.closest('.package-builder__back-button')) {
        const backButton = event.target.closest('.package-builder__back-button');
        const targetStep = parseInt(backButton.dataset.step);
        this.goToStep(targetStep);
      }
    });

    // Delivery date button clicks
    this.addEventListener('click', (event) => {
      if (event.target.matches('.package-builder__delivery-date-button')) {
        this.selectDeliveryDate(event.target);
      }
    });

    // Close button click
    this.addEventListener('click', (event) => {
      if (event.target.matches('.package-builder__close') || event.target.closest('.package-builder__close')) {
        this.close();
      }
    });
  }

  async open(productHandle) {
    try {
      this.packageData.productHandle = productHandle;
      
      // Get product data from the embedded JSON instead of API call
      const packageDataScript = document.getElementById(`product-data-${productHandle}`);
      if (!packageDataScript) {
        throw new Error(`Package builder data not found for product: ${productHandle}`);
      }
      
      const packageData = JSON.parse(packageDataScript.textContent);

      this.product = packageData.product;
      this.weeklyMenus = packageData.weeklyMenus;
      this.bundle = packageData.bundle;

      // Validate weekly menu compatibility before opening
      const validation = await WeeklyMenuUtils.validateWeeklyMenuCompatibility(packageData);
      
      let startingStep = 1;
      
      if (!validation.canProceed) {
        if (validation.action === 'selectMenu') {
          // Show weekly menu selection in package builder
          this.showWeeklyMenuConflictStep(validation);
        } else if (validation.action === 'resolveConflict') {
          // Show conflict resolution in package builder
          this.showWeeklyMenuConflictStep(validation);
        }
      } else {
        // If we have a valid selection, check if it's available for this product
        if (validation.selectedMenu && validation.selectedDeliveryDate) {
          const isMenuAvailableForProduct = this.isMenuAvailableForProduct(validation.selectedMenu, validation.selectedDeliveryDate);
          
          if (isMenuAvailableForProduct) {
            // Pre-populate the data and skip to step 2
            this.packageData.weeklyMenu = validation.selectedMenu;
            this.packageData.deliveryDate = this.findDeliveryDateInfo(validation.selectedMenu, validation.selectedDeliveryDate);
            startingStep = 2;
          } else {
            // Menu not available for this product, start from step 1
            this.prePopulateWeeklyMenuSelection(validation.selectedMenu, validation.selectedDeliveryDate);
          }
        }
      }

      this.initializePackageData();
      this.updateHeader();
      
      if (startingStep === 1) {
        this.populateWeeklyMenus();
        this.showStep(1);
      } else {
        // Skip step 1, go directly to step 2
        await this.goToStep2();
      }
      
      // Show the package builder
      this.classList.add('animate', 'active');

      this.addEventListener(
        'transitionend',
        () => {
          const focusElement = this.querySelector('.package-builder__inner');
          if (focusElement && typeof trapFocus === 'function') {
            trapFocus(this, focusElement);
          }
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    } catch (error) {
      console.error('Error opening package builder:', error);
    }
  }

  // checks to see if a package is abadoned. if so remove order date and do a hard refresh. If package is added to cart keep date
    close() {
      this.classList.remove('active');

      const header = document.querySelector('.cart-weekly-menu-header');
      const backToMenuLink = document.querySelector('.cart-back-to-menu__link');
      if (header) header.remove();
      if (backToMenuLink) backToMenuLink.remove();

      // ❗ ONLY CLEAR WEEKLY MENU DATA IF USER ABANDONED THE PACKAGE BUILDER
      if (!window.packageSuccessfullyAdded) {
        window.WeeklyMenuUtils?.clearSessionData?.();

        [
          'weeklyMenuSelection',
          'weeklyMenuDeliveryDate',
          'weeklyMenuCollectionHandle',
          'weeklyMenuTitle',
          'cartValidZipCode'
        ].forEach(k => {
          localStorage.removeItem(k);
          sessionStorage.removeItem(k);
        });

        console.log("Abandoned package → weekly menu data cleared");
      } else {
        console.log("Completed package → preserving weekly menu data");
      }

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }

      document.body.classList.remove('overflow-hidden');
      this.resetForm();

      // Reset the flag for next time
      window.packageSuccessfullyAdded = false;
    }


// original close method
  // close() {
  //   this.classList.remove('active');
    
  //   const header = document.querySelector('.cart-weekly-menu-header');
  //   const backToMenuLink = document.querySelector('.cart-back-to-menu__link')
  //   if (header) header.remove();
  //   if (backToMenuLink) backToMenuLink.remove();
    
  //   if (typeof removeTrapFocus === 'function') {
  //     removeTrapFocus();
  //   }
  //   document.body.classList.remove('overflow-hidden');
  //   this.resetForm();
  // }

  /**
   * Check if a menu and delivery date combination is available for this product
   */
  isMenuAvailableForProduct(selectedMenu, selectedDeliveryDate) {
    if (!this.weeklyMenus || !selectedMenu || !selectedDeliveryDate) {
      return false;
    }

    // Find the menu in this product's available menus
    const availableMenu = this.weeklyMenus.find(menu => menu.title === selectedMenu.title);
    if (!availableMenu) {
      return false;
    }

    // Check if the delivery date is available and not past its cutoff
    if (!availableMenu.delivery_dates) {
      return false;
    }

    const deliveryDateInfo = availableMenu.delivery_dates.find(dateInfo => dateInfo.date === selectedDeliveryDate);
    if (!deliveryDateInfo) {
      return false;
    }

    // Use the same availability check as used elsewhere
    return WeeklyMenuUtils.isDeliveryDateAvailable(deliveryDateInfo);
  }

  /**
   * Find delivery date info object for a menu and date string
   */
  findDeliveryDateInfo(selectedMenu, selectedDeliveryDate) {
    if (!selectedMenu || !selectedMenu.delivery_dates || !selectedDeliveryDate) {
      return null;
    }

    return selectedMenu.delivery_dates.find(dateInfo => dateInfo.date === selectedDeliveryDate) || null;
  }

  resetForm() {
    this.currentStep = 1;
    this.packageData = {
      productHandle: null,
      weeklyMenu: null,
      deliveryDate: null,
      mainsSelected: 0,
      sidesSelected: 0,
    };
    this.skipWeeklyMenuValidation = false;

    // Reset form elements
    const weeklyMenuSelect = this.querySelector('#weekly-menu-select');
    const dropdownContainer = this.querySelector('.package-builder__dropdown-container');

    if (weeklyMenuSelect) {
      weeklyMenuSelect.value = '';
    }

    // Reset visibility of form elements
    if (dropdownContainer) {
      dropdownContainer.style.display = 'block';
    }

    // Clear delivery dates
    const deliveryDatesContainer = this.querySelector('.package-builder__delivery-dates');
    if (deliveryDatesContainer) {
      deliveryDatesContainer.innerHTML = '';
    }

    // Reset button state
    const nextButton = this.querySelector('.package-builder__next-button');
    if (nextButton) {
      nextButton.disabled = true;
      nextButton.querySelector('.package-builder__button-text').textContent = 'Confirm';
    }
  }

  initializePackageData() {
    // Bundle data is already loaded from the embedded JSON
    if (this.bundle) {
      this.mainsMax = this.bundle.mains_max || 0;
      this.mainsAllowDuplicates = this.bundle.mains_allow_duplicates != false;
      console.debug('Bundle data:', this.bundle);
    } else {
      console.warn('No bundle data found');
    }

    this.quantities = {
      mains: {},
      sides: {},
      extras: {},
      addons: {}
    };

    this.packageData.mains = {};
    this.packageData.mainsSelected = 0;
  }

  populateWeeklyMenus() {
    const weeklyMenuSelect = this.querySelector('#weekly-menu-select');
    const dropdownContainer = this.querySelector('.package-builder__dropdown-container');
    if (!weeklyMenuSelect) {
      console.error('Weekly menu select not found');
      return;
    }

    if (!this.weeklyMenus) {
      console.warn('No weekly menus found in package data');
      return;
    }

    weeklyMenuSelect.innerHTML = '<option value="">Choose a weekly menu...</option>';

    const now = new Date();
    let preSelectedIndex = null;
    let visibleMenusCount = 0;
    let firstVisibleMenuIndex = null;

    this.weeklyMenus.forEach((menu, index) => {
      let isVisible = true;

      if (menu.visible_after_date) {
        const visibleAfterDate = WeeklyMenuUtils.parseESTDate(menu.visible_after_date);
        if (isNaN(visibleAfterDate.getTime())) {
          console.warn('Invalid visible_after_date for menu:', menu.title, menu.visible_after_date);
        } else if (now < visibleAfterDate) {
          isVisible = false;
        }
      }

      if (menu.hidden_after_date && isVisible) {
        const hiddenAfterDate = WeeklyMenuUtils.parseESTDate(menu.hidden_after_date);
        if (isNaN(hiddenAfterDate.getTime())) {
          console.warn('Invalid hidden_after_date for menu:', menu.title, menu.hidden_after_date);
        } else if (now > hiddenAfterDate) {
          isVisible = false;
        }
      }

      if (isVisible) {
        const option = document.createElement('option');
        option.value = index;
        option.textContent = menu.title || `Menu ${index + 1}`;
        weeklyMenuSelect.appendChild(option);

        visibleMenusCount++;
        if (firstVisibleMenuIndex === null) {
          firstVisibleMenuIndex = index;
        }

        // Check if this should be pre-selected
        if (this.prePopulatedMenuIndex === index) {
          preSelectedIndex = index;
        }
      }
    });

    // Hide dropdown if only one menu is available and auto-select it
    if (visibleMenusCount === 1 && firstVisibleMenuIndex !== null) {
      if (dropdownContainer) {
        dropdownContainer.style.display = 'none';
      }

      preSelectedIndex = firstVisibleMenuIndex;
    } else if (dropdownContainer) {
      dropdownContainer.style.display = 'block';
    }

    // Pre-populate if we have a pre-selected menu
    if (preSelectedIndex !== null) {
      weeklyMenuSelect.value = preSelectedIndex;
      this.packageData.weeklyMenu = this.weeklyMenus[preSelectedIndex];
      
      // Also pre-populate delivery dates
      this.populateDeliveryDates();
      
      // Pre-select delivery date if available
      if (this.prePopulatedDeliveryDate) {
        setTimeout(() => {
          const deliveryButtons = this.querySelectorAll('.package-builder__delivery-date-button');
          deliveryButtons.forEach(button => {
            const index = parseInt(button.dataset.index);
            const dateInfo = this.packageData.weeklyMenu.delivery_dates[index];
            if (dateInfo && dateInfo.date === this.prePopulatedDeliveryDate) {
              this.selectDeliveryDate(button);
            }
          });
        }, 100);
      }
      
      // Clear pre-population flags
      this.prePopulatedMenuIndex = null;
      this.prePopulatedDeliveryDate = null;
    }
  }

  onWeeklyMenuChange(event) {
    const selectedIndex = event.target.value;
    console.debug('Weekly menu changed:', selectedIndex);
    
    if (selectedIndex === '') {
      this.packageData.weeklyMenu = null;
      this.clearDeliveryDates();
      this.updateNextButton();
      return;
    }

    // Use filtered menus if available (for conflict resolution), otherwise use original array
    const menusArray = this.filteredWeeklyMenus || this.weeklyMenus;
    this.packageData.weeklyMenu = menusArray[selectedIndex];
    
    this.populateDeliveryDates();
    this.updateNextButton();
  }

  populateDeliveryDates() {
    const deliveryDatesContainer = this.querySelector('.package-builder__delivery-dates');
    console.debug('Weekly menu data:', this.packageData.weeklyMenu);

    if (!deliveryDatesContainer) {
      console.error('Delivery dates container not found!');
      return;
    }
    
    if (!this.packageData.weeklyMenu) {
      console.debug('No weekly menu data available');
      return;
    }

    const deliveryDates = this.packageData.weeklyMenu.delivery_dates || [];

    // Clear container first
    deliveryDatesContainer.innerHTML = '';

    if (deliveryDates.length === 0) {
      console.debug('No delivery dates in the weekly menu');
      const noDataMessage = document.createElement('p');
      noDataMessage.textContent = 'No delivery dates available for this menu.';
      deliveryDatesContainer.appendChild(noDataMessage);
      return;
    }

    const now = new Date();

    // Create array of delivery dates with their metadata and sort by delivery date
    const sortedDeliveryDates = deliveryDates
      .map((dateInfo, originalIndex) => {
        if (!dateInfo || !dateInfo.date) {
          return null;
        }

        const deliveryDate = new Date(dateInfo.date + 'T12:00:00');
        if (isNaN(deliveryDate.getTime())) {
          console.debug('Invalid delivery date:', dateInfo.date);
          return null;
        }

        const cutoffDate = dateInfo.cutoff_date ? WeeklyMenuUtils.parseESTDate(dateInfo.cutoff_date) : null;
        if (cutoffDate && isNaN(cutoffDate.getTime())) {
          console.debug('Invalid cutoff date:', dateInfo.cutoff_date);
        }

        return {
          ...dateInfo,
          deliveryDate,
          cutoffDate,
          originalIndex
        };
      })
      .filter(Boolean) // Remove null entries
      .sort((a, b) => a.deliveryDate - b.deliveryDate); // Sort by delivery date (earliest first)

    let availableDatesCount = 0;

    sortedDeliveryDates.forEach((dateInfo) => {
      const { deliveryDate, cutoffDate, originalIndex } = dateInfo;

      // Check if delivery date has passed
      const deliveryDateOnly = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());
      const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const isDeliveryPast = deliveryDateOnly < nowDateOnly;

      // Check if cutoff date has passed
      const isCutoffPast = cutoffDate && cutoffDate < now;

      // Determine if this date should be disabled
      const isDisabled = isDeliveryPast || isCutoffPast;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'package-builder__delivery-date-button';
      button.dataset.index = originalIndex; // Keep original index for data access
      
      if (isDisabled) {
        button.disabled = true;
        button.title = isCutoffPast 
          ? 'Order cutoff time has passed for this delivery date'
          : 'This delivery date has already passed';
        console.debug('Disabling past date - isDeliveryPast:', isDeliveryPast, 'isCutoffPast:', isCutoffPast);
      } else {
        availableDatesCount++;
      }
      
      try {
        button.textContent = this.formatDeliveryDate(deliveryDate);
      } catch (error) {
        console.error('Error formatting delivery date:', error);
        button.textContent = dateInfo.date;
      }

      deliveryDatesContainer.appendChild(button);
    });

    console.debug('Final delivery dates container children:', deliveryDatesContainer.children.length);
    console.debug('Available (non-disabled) dates:', availableDatesCount);

    if (availableDatesCount === 0) {
      const noValidDatesMessage = document.createElement('p');
      noValidDatesMessage.textContent = 'No upcoming delivery dates available.';
      deliveryDatesContainer.appendChild(noValidDatesMessage);
    }
  }

  clearDeliveryDates() {
    const deliveryDatesContainer = this.querySelector('.package-builder__delivery-dates');
    if (deliveryDatesContainer) {
      deliveryDatesContainer.innerHTML = '';
    }
    this.packageData.deliveryDate = null;
  }

  selectDeliveryDate(button) {
    // Don't allow selection of disabled dates
    if (button.disabled) {
      return;
    }

    // Remove selection from other buttons
    this.querySelectorAll('.package-builder__delivery-date-button').forEach(btn => {
      btn.classList.remove('selected');
    });

    // Select this button
    button.classList.add('selected');

    const index = parseInt(button.dataset.index);
    this.packageData.deliveryDate = this.packageData.weeklyMenu.delivery_dates[index];
    this.updateNextButton();
  }

  updateNextButton() {
    const nextButton = this.querySelector('.package-builder__next-button');
    if (!nextButton) return;

    let isEnabled = false;
    let buttonText = 'Confirm';

    if (this.currentStep === 1) {
      isEnabled = this.packageData.weeklyMenu && this.packageData.deliveryDate;
      buttonText = 'Confirm';
    } else if (this.currentStep === 2) {
      isEnabled = this.packageData.mainsSelected === this.mainsMax;
      buttonText = 'Continue to sides';
    } else if (this.currentStep === 3) {
      isEnabled = this.packageData.sidesSelected === this.sidesMax;
      buttonText = 'Continue to snacks';
    } else if (this.currentStep === 4) {
      isEnabled = true;
      buttonText = 'Continue to add-ons';
    } else if (this.currentStep === 5) {
      isEnabled = true;
      buttonText = 'Confirm';
    } else if (this.currentStep === 6) {
      isEnabled = true;
      buttonText = 'Add to cart';
    }

    nextButton.disabled = !isEnabled;
    const buttonTextElement = nextButton.querySelector('.package-builder__button-text');
    if (buttonTextElement) {
      buttonTextElement.textContent = buttonText;
    } else {
      // Fallback if button-text element doesn't exist
      nextButton.textContent = buttonText;
    }
  }

  onNextButtonClick() {
    if (this.currentStep === 1) {
      this.goToStep2();
    } else if (this.currentStep === 2) {
      this.goToStep3();
    } else if (this.currentStep === 3) {
      this.goToStep4();
    } else if (this.currentStep === 4) {
      this.goToStep5();
    } else if (this.currentStep === 5) {
      this.goToStep6();
    } else if (this.currentStep === 6) {
      this.addToCart();
    }
  }

  async goToStep2() {
    // Save weekly menu selection to session storage (only if not already set)
    if (this.packageData.weeklyMenu && this.packageData.deliveryDate) {
      const sessionData = WeeklyMenuUtils.getSessionData();
      
      // Only update session data if it's different from what we have
      if (sessionData.weeklyMenuTitle !== this.packageData.weeklyMenu.title || 
          sessionData.deliveryDate !== this.packageData.deliveryDate.date) {
        WeeklyMenuUtils.setEnrichedSessionData(this.packageData.weeklyMenu, this.packageData.deliveryDate);

        // Notify other components about the selection
        WeeklyMenuUtils.notifyWeeklyMenuChange({
          menu: this.packageData.weeklyMenu,
          deliveryDate: this.packageData.deliveryDate,
          source: 'package-builder'
        });
      }
    }

    this.currentStep = 2;
    this.updateHeader();
    await this.populateMainsProducts();

    this.restoreMainsQuantities();

    this.showStep(2);
    this.updateNextButton();
  }

  async goToStep3() {
    this.currentStep = 3;
    this.updateHeader();
    await this.populateSidesProducts();

    this.restoreSidesQuantities();
    
    this.showStep(3);
    this.updateNextButton();
  }

  async goToStep4() {
    this.currentStep = 4;
    this.updateHeader();
    await this.populateExtrasProducts();

    this.restoreExtrasQuantities();

    this.showStep(4);
    this.updateNextButton();
  }

  async goToStep5() {
    if (!this.bundle?.addons || this.bundle?.addons.length === 0) {
      this.goToStep6();
      return;
    }

    this.currentStep = 5;
    this.updateHeader();
    await this.populateAddonsProducts();

    this.restoreAddonsQuantities();
    
    this.showStep(5);
    this.updateNextButton();
  }

  async goToStep6() {
    this.currentStep = 6;
    this.updateHeader();
    this.showStep(6);
    this.updateNextButton();
    this.setupGiftFunctionality();
  }

  async goToStep(stepNumber) {
    if (this.currentStep === 5) {
      this.updateAddonsCounter();
    }

    switch (stepNumber) {
      case 2:
        await this.goToStep2();
        break;
      case 3:
        await this.goToStep3();
        break;
      case 4:
        await this.goToStep4();
        break;
      case 5:
        await this.goToStep5();
        break;
      case 6:
        await this.goToStep6();
        break;
      default:
        console.debug('Unknown step:', stepNumber);
    }
  }

  showStep(stepNumber) {
    this.querySelectorAll('.package-builder__step').forEach(step => {
      step.classList.remove('active');
    });

    const targetStep = this.querySelector(`.package-builder__step[data-step="${stepNumber}"]`);
    if (targetStep) {
      targetStep.classList.add('active');
    }
  }

  async populateMainsProducts() {
    const container = this.querySelector('.package-builder__products-list');
    if (!container || !this.bundle?.mains) return;

    container.innerHTML = '';

    // Use the embedded product data directly instead of fetching
    for (const mainProduct of this.bundle.mains) {
      try {
        // Use the embedded product data if it has all the required fields
        let product = mainProduct;

        // If the embedded data doesn't have metafields, fetch the full product
        if (!mainProduct.metafields) {
          const productUrl = `/products/${mainProduct.handle}.js`;
          const response = await fetch(productUrl);
          product = await response.json();
        }

        // Initialize quantity tracking
        this.quantities.mains[product.id] = this.quantities.mains[product.id] ?? 0;

        const productCard = this.createProductCard(product);
        container.appendChild(productCard);
      } catch (error) {
        console.error('Error processing main product:', error, mainProduct);
      }
    }
  }

  async populateSidesProducts() {
    const container = this.querySelector('.package-builder__grid[data-type="sides"]');
    if (!container || !this.bundle?.sides) {
      // If no sides, skip to next step
      this.goToStep(4);
      return;
    }

    container.innerHTML = '';

    // Initialize sides tracking
    this.sidesMax = this.bundle.sides_max || 0;
    this.sidesAllowDuplicates = this.bundle.sides_allow_duplicates != false;

    // Update header info
    this.updateHeader();

    // Use the embedded product data directly instead of fetching
    for (const sideProduct of this.bundle.sides) {
      try {
        // Use the embedded product data if it has all the required fields
        let product = sideProduct;

        // If the embedded data doesn't have metafields, fetch the full product
        if (!sideProduct.metafields) {
          const productUrl = `/products/${sideProduct.handle}.js`;
          const response = await fetch(productUrl);
          product = await response.json();
        }

        // Initialize quantity tracking
        this.quantities.sides[product.id] = this.quantities.sides[product.id] ?? 0;

        const productCard = this.createSidesCard(product);
        container.appendChild(productCard);
      } catch (error) {
        console.error('Error processing side product:', error, sideProduct);
      }
    }

    this.updateNextButton();
  }

  updateAddonsQuantity(productId, change) {
    const currentQuantity = this.quantities.addons[productId] || 0;
    const newQuantity = Math.max(0, currentQuantity + change);

    this.quantities.addons[productId] = newQuantity;

    // Update the displayed quantity
    const input = this.querySelector(`[data-step="5"] .quantity__input[data-product-id="${productId}"]`);
    if (input) {
      input.value = newQuantity;
    }

    this.updateAddonsCounter();
  }

  updateAddonsCounter() {
    const total = Object.values(this.quantities.addons).reduce((sum, quantity) => sum + quantity, 0);
    this.updateBubbleCounter(total);
  }

  setupGiftFunctionality() {
    const giftCheckbox = this.querySelector('#giftCheckbox');
    const giftMessageWrapper = this.querySelector('.package-builder__gift-message-wrapper');
    const giftMessage = this.querySelector('#giftMessage');

    if (giftCheckbox && giftMessageWrapper) {
      giftCheckbox.addEventListener('change', () => {
        if (giftCheckbox.checked) {
          giftMessageWrapper.style.display = 'block';
        } else {
          giftMessageWrapper.style.display = 'none';
          if (giftMessage) {
            giftMessage.value = '';
          }
        }
      });
    }
  }

  async addToCart() {
    try {
      // Validate weekly menu compatibility before adding to cart
      if (!this.skipWeeklyMenuValidation) {
        const packageData = { product: this.product, weeklyMenus: this.weeklyMenus, bundle: this.bundle };
        const validation = await WeeklyMenuUtils.validateWeeklyMenuCompatibility(packageData);
        
        if (!validation.canProceed) {
          if (validation.action === 'resolveConflict') {
            // Show conflict resolution UI - the user needs to decide what to do
            this.showWeeklyMenuConflictStep(validation);
            return;
          }
          // For other cases, the validation should have been handled in the open() method
          console.warn('Weekly menu validation failed, but no appropriate action available');
          return;
        }
      }

      // Helper function to get product variant ID and title by product ID
      const getProductInfo = (productId) => {
        let product = null;

        if (this.bundle?.mains) {
          product = this.bundle.mains.find(p => p.id.toString() === productId.toString());
        }

        if (!product && this.bundle?.sides) {
          product = this.bundle.sides.find(p => p.id.toString() === productId.toString());
        }

        if (!product && this.bundle?.extras) {
          product = this.bundle.extras.find(p => p.id.toString() === productId.toString());
        }

        if (!product && this.bundle?.addons) {
          product = this.bundle?.addons.find(p => p.id.toString() === productId.toString());
        }

        if (product) {
          return {
            variantId: product.variant_id || (product.variants && product.variants[0]?.id),
            title: product.title,
            price: product.price
          };
        }

        return { variantId: null, title: null, price: null };
      };

      // Generate bundle ID and timestamp
      const timestamp = Math.floor(Date.now() / 1000);
      const bundleId = `stocked-bundle-${this.product.id}-${timestamp}`;

      // Collect bundle variants (mains, sides, and extras are all part of the bundle)
      const bundleVariants = [];

      // Collect product titles for display
      const mainsNames = [];
      const sidesNames = [];
      const extrasNames = [];

      // Process mains - these are part of the bundle
      if (this.quantities.mains) {
        Object.entries(this.quantities.mains).forEach(([productId, quantity]) => {
          if (quantity > 0) {
            const { variantId, title } = getProductInfo(productId);
            if (variantId) {
              bundleVariants.push({
                id: `gid://shopify/ProductVariant/${variantId}`,
                legacy_id: variantId,
                quantity
              });
              if (title) mainsNames.push(title);
            }
          }
        });
      }

      // Process sides - these are part of the bundle
      if (this.quantities.sides) {
        Object.entries(this.quantities.sides).forEach(([productId, quantity]) => {
          if (quantity > 0) {
            const { variantId, title } = getProductInfo(productId);
            if (variantId) {
              bundleVariants.push({
                id: `gid://shopify/ProductVariant/${variantId}`,
                legacy_id: variantId,
                quantity,
              });
              if (title) sidesNames.push(title);
            }
          }
        });
      }

      // Process extras - these are part of the bundle
      if (this.quantities.extras) {
        Object.entries(this.quantities.extras).forEach(([productId, quantity]) => {
          if (quantity > 0) {
            const { variantId, title } = getProductInfo(productId);
            if (variantId) {
              bundleVariants.push({
                id: `gid://shopify/ProductVariant/${variantId}`,
                legacy_id: variantId,
                quantity
              });
              if (title) extrasNames.push(title);
            }
          }
        });
      }

      // Build the properties object for the main package using WeeklyMenuUtils
      const properties = WeeklyMenuUtils.getCartPropertiesForMenu(
        this.packageData.weeklyMenu, 
        this.packageData.deliveryDate, 
        {
          _WeeklyMenuExempt: 'false',
          _bundleId: bundleId,
          _bundleCost: this.product.price ? this.product.price / 100 : 0,
          _bundleVariants: JSON.stringify(bundleVariants)
        }
      );

      // Add human-readable product lists for bundle items (mains, sides, and extras)
      if (mainsNames.length > 0) {
        properties.mains = mainsNames.join(', ');
      }
      if (sidesNames.length > 0) {
        properties.sides = sidesNames.join(', ');
      }
      if (extrasNames.length > 0) {
        properties.extras = extrasNames.join(', ');
      }

      // Add gift note if provided
      const giftCheckbox = this.querySelector('#giftCheckbox');
      const giftMessage = this.querySelector('#giftMessage');
      if (giftCheckbox?.checked && giftMessage?.value) {
        properties.gift_note = giftMessage.value;
      }

      // Create the main package item
      const packageItem = {
        id: this.product.variants[0].id,
        quantity: 1,
        properties: properties
      };

      // Create array of all items to add (package + add-ons only)
      const itemsToAdd = [packageItem];

      // Process add-ons as separate line items
      if (this.quantities.addons) {
        Object.entries(this.quantities.addons).forEach(([productId, quantity]) => {
          if (quantity > 0) {
            const { variantId } = getProductInfo(productId);
            if (variantId) {
              const addonProperties = WeeklyMenuUtils.getCartPropertiesForMenu(
                this.packageData.weeklyMenu, 
                this.packageData.deliveryDate, 
                {
                  _WeeklyMenuExempt: 'true',
                  _bundleId: bundleId,
                  _itemType: 'addon'
                }
              );

              itemsToAdd.push({
                id: variantId,
                quantity: quantity,
                properties: addonProperties
              });
            }
          }
        });
      }

      // Add all items to cart via Shopify AJAX API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: itemsToAdd
        })
      });

      if (response.ok) {
        // Reset the skip flag
        this.skipWeeklyMenuValidation = false;
        
        window.packageSuccessfullyAdded = true;
        this.close();

        // Set flag to open cart after page refresh
        localStorage.setItem('openCartAfterRefresh', 'true');

        // Refresh the page to update all cart-related UI
        window.location.reload();
      } else {
        const errorData = await response.json();
        console.error('Cart add response error:', errorData);
        throw new Error('Failed to add to cart');
      }

    } catch (error) {
      console.error('Error adding package to cart:', error);
      // Reset the skip flag on error too
      this.skipWeeklyMenuValidation = false;
      // You could show an error message to the user here
    }
  }

  async populateExtrasProducts() {
    const container = this.querySelector('.package-builder__grid[data-type="extras"]');
    if (!container || !this.bundle?.extras) {
      // If no extras, skip to next step
      this.goToStep(5);
      return;
    }

    container.innerHTML = '';

    this.updateHeader();

    this.updateBubbleCounter(0);

    for (const extraProduct of this.bundle.extras) {
      try {
        // Use the embedded product data if it has all the required fields
        let product = extraProduct;

        // If the embedded data doesn't have metafields, fetch the full product
        if (!extraProduct.metafields) {
          const productUrl = `/products/${extraProduct.handle}.js`;
          const response = await fetch(productUrl);
          product = await response.json();
        }

        // Always set extras to quantity 1 (non-editable)
        this.quantities.extras[product.id] = this.quantities.extras[product.id] ?? 1;

        // Always create extras as included/non-editable
        const productCard = this.createExtrasCard(product, true);
        container.appendChild(productCard);
      } catch (error) {
        console.error('Error processing extra product:', error, extraProduct);
      }
    }

    this.updateNextButton();
  }

  async populateAddonsProducts() {
    const container = this.querySelector('.package-builder__grid[data-type="addons"]');
    if (!container) {
      console.error('Add-ons container not found');
      return;
    }

    container.innerHTML = '';

    this.updateHeader();

    this.updateBubbleCounter(0);

    // Use the embedded product data directly instead of fetching
    for (const addon of this.bundle?.addons || []) {
      try {
        // Use the embedded product data if it has all the required fields
        let product = addon;
        
        // If the embedded data doesn't have metafields, fetch the full product
        if (!addon.metafields) {
          const productUrl = `/products/${addon.handle}.js`;
          const response = await fetch(productUrl);
          product = await response.json();
        }
        
        // Initialize quantity tracking
        this.quantities.addons[product.id] = this.quantities.addons[product.id] ?? 0;

        const productCard = this.createAddonsCard(product);
        container.appendChild(productCard);
      } catch (error) {
        console.error('Error processing addon product:', error, addon);
      }
    }

    this.updateNextButton();
  }

  createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'package-builder__product-card';
    card.dataset.productId = product.id;

    const ingredients = product.metafields?.custom?.ingredients || '';
    const allergens = product.metafields?.custom?.allergens || '';

    // Handle image URL - ensure it has a protocol
    let imageUrl = product.featured_image || product.images?.[0] || '';
    if (imageUrl && imageUrl !== 'null' && !imageUrl.startsWith('http')) {
      imageUrl = 'https:' + imageUrl;
    }

    card.innerHTML = `
      <div class="package-builder__product-image">
        ${imageUrl && imageUrl !== 'null' ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : `<div class="package-builder__no-image">No Image</div>`}
      </div>
      <div class="package-builder__product-details">
        <div class="package-builder__product-main-info">
          <div class="package-builder__product-info">
            <h3 class="package-builder__product-name">${product.title}</h3>
            <div class="package-builder__product-serving">
              <div class="quantity cart-quantity">
                <button class="quantity__button" name="minus" type="button" data-action="decrease" data-product-id="${product.id}">
                  <span class="visually-hidden">Decrease quantity for ${product.title}</span>
                  <span class="svg-wrapper">${this.getMinusIcon()}</span>
                </button>
                <input
                  class="quantity__input"
                  type="number"
                  value="0"
                  min="0"
                  readonly
                  data-product-id="${product.id}"
                  aria-label="Quantity for ${product.title}"
                >
                <button class="quantity__button" name="plus" type="button" data-action="increase" data-product-id="${product.id}">
                  <span class="visually-hidden">Increase quantity for ${product.title}</span>
                  <span class="svg-wrapper">${this.getPlusIcon()}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="package-builder__product-attributes">
        ${ingredients ?
          `<div class="package-builder__attribute">
            <p class="package-builder__attribute-label">Ingredients</p>
            <p>${ingredients}</p>
          </div>` : ''
        }
        ${allergens ?
          `<div class="package-builder__attribute">
            <p class="package-builder__attribute-label">Allergen Info</p>
            <p>${allergens}</p>
          </div>` : ''
        }
        </div>
      </div>
    `;

    // Add event listeners for quantity buttons
    const decreaseBtn = card.querySelector('[data-action="decrease"]');
    const increaseBtn = card.querySelector('[data-action="increase"]');
    
    decreaseBtn.addEventListener('click', () => this.updateMainsQuantity(product.id, -1));
    increaseBtn.addEventListener('click', () => this.updateMainsQuantity(product.id, 1));

    return card;
  }

  createGenericCard(product, type = 'sides', allIncluded = false) {
    const card = document.createElement('div');
    card.className = `package-builder__card`;
    card.dataset.productId = product.id;

    // Extract product information
    const price = this.formatMoney(product.price || '');
    const servingSize = product.metafields?.custom?.serving_size || '';
    const plpServingSize = product.metafields?.custom?.plp_serving_size || '';
    const allergens = product.metafields?.custom?.allergens || '';

    // Format serving info - only show for extras and addons
    let servingInfo = '';
    if (type === 'addons') {
      servingInfo = [price, plpServingSize, servingSize].filter(Boolean).join(' • ');
    }

    // Handle image URL - ensure it has a protocol
    let imageUrl = product.featured_image || product.images?.[0] || '';
    if (imageUrl && !imageUrl.startsWith('http')) {
      imageUrl = 'https:' + imageUrl;
    }

    // Different footer content based on whether the item is included or optional
    const footerContent = `<div class="quantity cart-quantity">
          <button class="quantity__button" name="minus" type="button" data-action="decrease" data-product-id="${product.id}">
            <span class="visually-hidden">Decrease quantity for ${product.title}</span>
            <span class="svg-wrapper">${this.getMinusIcon()}</span>
          </button>
          <input
            class="quantity__input"
            type="number"
            value="${allIncluded ? 1 : 0}"
            min="0"
            readonly
            data-product-id="${product.id}"
            aria-label="Quantity for ${product.title}"
          >
          <button class="quantity__button" name="plus" type="button" data-action="increase" data-product-id="${product.id}">
            <span class="visually-hidden">Increase quantity for ${product.title}</span>
            <span class="svg-wrapper">${this.getPlusIcon()}</span>
          </button>
        </div>`;

    card.innerHTML = `
      <div class="package-builder__card-content">
        <div class="package-builder__card-top">
          <div class="package-builder__card-image">
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : `<div class="package-builder__no-image">No Image</div>`}
          </div>
          ${allergens ?
            `<div class="package-builder__card-allergens">
                ${type === 'sides' ? `<p class="package-builder__attribute-label">Allergen Info</p>` : ''}
                <p>${allergens}</p>
            </div>` : ''}
        </div>
        <p class="package-builder__card-title">${product.title}</p>
        ${(type === 'extras' || type === 'addons') && servingInfo ? `<p class="package-builder__card-serving">${servingInfo}</p>` : ''}
      </div>
      <div class="package-builder__card-footer">
        ${footerContent}
      </div>
    `;

    if (allIncluded) {
        return card;
    }

    // Add event listeners for quantity buttons if not all included
    const decreaseBtn = card.querySelector('[data-action="decrease"]');
    const increaseBtn = card.querySelector('[data-action="increase"]');

    // Use appropriate update method based on type
    if (type === 'sides') {
        decreaseBtn.addEventListener('click', () => this.updateSidesQuantity(product.id, -1));
        increaseBtn.addEventListener('click', () => this.updateSidesQuantity(product.id, 1));
    } else if (type === 'extras') {
        decreaseBtn.addEventListener('click', () => this.updateExtrasQuantity(product.id, -1));
        increaseBtn.addEventListener('click', () => this.updateExtrasQuantity(product.id, 1));
    } else if (type === 'addons') {
        decreaseBtn.addEventListener('click', () => this.updateAddonsQuantity(product.id, -1));
        increaseBtn.addEventListener('click', () => this.updateAddonsQuantity(product.id, 1));
    }

    return card;
  }

  createSidesCard(product) {
    return this.createGenericCard(product, 'sides');
  }

  createExtrasCard(product, allIncluded = true) {
    return this.createGenericCard(product, 'extras', allIncluded);
  }

  createAddonsCard(product) {
    return this.createGenericCard(product, 'addons');
  }

  updateQuantityButtons() {
    const canAddMore = this.packageData.mainsSelected < this.mainsMax;
    
    // Only update buttons in step 2 (mains)
    const step2 = this.querySelector('.package-builder__step[data-step="2"]');
    if (!step2) return;
    
    step2.querySelectorAll('.quantity__button[data-action="increase"]').forEach(button => {
      const productId = button.dataset.productId;
      const input = this.querySelector(`input[data-product-id="${productId}"]`);
      const currentQuantity = parseInt(input.value) || 0;
      const maxQuantity = this.mainsAllowDuplicates ? this.mainsMax : 1;

      button.disabled = !canAddMore || currentQuantity >= maxQuantity;
    });

    step2.querySelectorAll('.quantity__button[data-action="decrease"]').forEach(button => {
      const productId = button.dataset.productId;
      const input = this.querySelector(`input[data-product-id="${productId}"]`);
      const currentQuantity = parseInt(input.value) || 0;

      button.disabled = currentQuantity <= 0;
    });
  }

  updateMainsQuantity(productId, change) {
    const currentQuantity = this.quantities.mains[productId] || 0;
    const maxQuantity = this.mainsAllowDuplicates ? this.mainsMax : 1;
    let newQuantity = currentQuantity;

    if (change > 0) {
      // Check if we can add more
      if (this.packageData.mainsSelected < this.mainsMax && currentQuantity < maxQuantity) {
        newQuantity = currentQuantity + 1;
        this.packageData.mainsSelected++;
      }
    } else if (change < 0) {
      if (currentQuantity > 0) {
        newQuantity = currentQuantity - 1;
        this.packageData.mainsSelected--;
      }
    }

    // Update quantities tracking
    if (newQuantity === 0) {
      delete this.quantities.mains[productId];
    } else {
      this.quantities.mains[productId] = newQuantity;
    }

    // Update the displayed quantity
    const input = this.querySelector(`[data-product-id="${productId}"].quantity__input`);
    if (input) {
      input.value = newQuantity;
    }

    // Update button states and bubble counter
    this.updateQuantityButtons();
    const remaining = this.mainsMax - this.packageData.mainsSelected;
    this.updateBubbleCounter(Math.max(0, remaining));
    this.updateNextButton();
  }

  updateSidesQuantity(productId, change) {
    const currentQuantity = this.quantities.sides[productId] || 0;
    const newQuantity = Math.max(0, currentQuantity + change);

    const currentTotal = Object.values(this.quantities.sides).reduce((sum, qty) => sum + qty, 0);
    const newTotal = currentTotal - currentQuantity + newQuantity;

    if (newTotal > this.sidesMax) {
      this.updateNextButton();
      return;
    }

    if (!this.sidesAllowDuplicates && newQuantity > 1) {
      console.debug('Duplicates not allowed for sides');
      return;
    }

    this.packageData.sidesSelected = newTotal;
    this.quantities.sides[productId] = newQuantity;

    const input = this.querySelector(`[data-product-id="${productId}"].quantity__input`);
    if (input) {
      input.value = newQuantity;
    }

    const remaining = this.sidesMax - newTotal;
    this.updateBubbleCounter(Math.max(0, remaining));

    this.updateNextButton();
  }

  updateBubbleCounter(count) {
    const counter = this.querySelector('.package-builder__bubble-counter');
    if (counter) {
      counter.textContent = count;
    }
  }

  updateExtrasQuantity(productId, change) {
    // Check if this extra is included by default
    const extrasAllIncluded = this.bundle?.extras_all_included === true;

    if (extrasAllIncluded) {
      // For included extras, minimum is 1
      const currentQuantity = this.quantities.extras[productId] || 1;
      const newQuantity = Math.max(1, currentQuantity + change);
      this.quantities.extras[productId] = newQuantity;
    } else {
      // For optional extras, minimum is 0
      const currentQuantity = this.quantities.extras[productId] || 0;
      const newQuantity = Math.max(0, currentQuantity + change);
      this.quantities.extras[productId] = newQuantity;
    }

    const input = this.querySelector(`[data-product-id="${productId}"].quantity__input`);
    if (input) {
      input.value = this.quantities.extras[productId];
    }

    const totalAdditional = Object.values(this.quantities.extras).reduce((sum, qty) => sum + (qty - 1), 0);
    this.updateBubbleCounter(totalAdditional);
  }

  updateHeader() {
    const closeButton = this.querySelector('.package-builder__close-button');
    const title = this.querySelector('.package-builder__header-title');
    title?.classList.remove('package-builder__header-title--first-step');
    const subtitle = this.querySelector('.package-builder__header-subtitle');
    const counter = this.querySelector('.package-builder__bubble-counter');

    switch (this.currentStep) {
      case 1:
        if (closeButton) closeButton.style.display = 'flex';
        if (title) {
          title.textContent = this.product?.title + ' • ' + this.formatMoney(this.product?.price)
          title?.classList.add('package-builder__header-title--first-step');
        };
        if (subtitle) subtitle.style.display = 'none';
        if (counter) counter.style.display = 'none';
        break;
      case 2:
        if (closeButton) closeButton.style.display = 'flex';
        if (title) title.textContent = this.bundle?.mains_title || 'Select Your Mains';
        if (subtitle) subtitle.style.display = 'block';
        if (subtitle) subtitle.textContent = this.bundle?.mains_subtitle || `Choose up to ${this.bundle?.mains_max || 'unlimited'} mains`;
        if (counter) {
            counter.style.display = 'flex';
            counter.textContent = this.mainsMax || 0;
        }
        break;
      case 3:
        if (title) title.textContent = this.bundle?.sides_title || 'Select Your Sides';
        if (subtitle) subtitle.textContent = this.bundle?.sides_subtitle || `Choose up to ${this.bundle?.sides_max || 'unlimited'} sides`;
        if (counter) {
          counter.style.display = 'flex';
          counter.textContent = this.sidesMax || 0;
        }
        break;
      case 4:
        if (title) title.textContent = this.bundle?.extras_title || 'Select Your Extras';
        if (subtitle) subtitle.textContent = 'Your package includes a thoughtfully selected trio of our homemade snacks.';
        if (counter) {
          counter.style.display = 'flex';
          // Show additional extras beyond the base included ones
          const totalAdditional = Object.values(this.extrasQuantities || {}).reduce((sum, qty) => sum + (qty - 1), 0);
          counter.textContent = totalAdditional;
        }
        break;
      case 5:
        if (title) title.textContent = 'Select Your Add-ons';
        if (subtitle) subtitle.textContent = 'Add our best selling snacks from our provisions store to your order.';
        if (counter) {
          counter.style.display = 'flex';
          counter.textContent = 0;
        }
        break;
      case 6:
        if (title) title.textContent = this.product?.title + ' • ' + this.formatMoney(this.product?.price);
        if (subtitle) {
            const deliveryDate = WeeklyMenuUtils.parseESTDate(this.packageData.deliveryDate.date + 'T12:00:00');
            subtitle.innerHTML = 'Delivering for <strong>' + this.formatDeliveryDate(deliveryDate) + '</strong>';
        }
        if (counter) counter.style.display = 'none';
        break;
    }
  }

  restoreMainsQuantities() {
    Object.entries(this.quantities.mains || {}).forEach(([productId, quantity]) => {
      const input = this.querySelector(`[data-product-id="${productId}"].quantity__input`);
      if (input) {
        input.value = quantity;
      }
    });
  }

  restoreSidesQuantities() {
    Object.entries(this.quantities.sides || {}).forEach(([productId, quantity]) => {
        const input = this.querySelector(`[data-step="3"] .quantity__input[data-product-id="${productId}"]`);
        if (input) {
            input.value = quantity;
        }
    });

    // Update bubble counter
    const totalSelected = Object.values(this.quantities.sides).reduce((sum, qty) => sum + qty, 0);
    const remaining = this.sidesMax - totalSelected;
    this.updateBubbleCounter(Math.max(0, remaining));
  }

  restoreExtrasQuantities() {
    // Restore extras quantities when returning to step 4
    Object.entries(this.quantities.extras || {}).forEach(([productId, quantity]) => {
      const input = this.querySelector(`[data-step="4"] .quantity__input[data-product-id="${productId}"]`);
      if (input) {
        input.value = quantity;
      }
    });

    // Update bubble counter for extras
    const totalAdditional = Object.values(this.quantities.extras).reduce((sum, qty) => sum + (qty - 1), 0);
    this.updateBubbleCounter(totalAdditional);
  }

  restoreAddonsQuantities() {
    // Restore addons quantities when returning to step 5
    Object.entries(this.quantities.addons || {}).forEach(([productId, quantity]) => {
      const input = this.querySelector(`[data-step="5"] .quantity__input[data-product-id="${productId}"]`);
      if (input) {
        input.value = quantity;
      }
    });

    // Update bubble counter for addons
    this.updateAddonsCounter();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  formatDeliveryDate(date) {
    const options = { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric'
    };
    
    const formatted = date.toLocaleDateString('en-US', options);
    // Convert "May 4" to "May 4th", "May 1" to "May 1st", etc.
    return formatted.replace(/(\d+)/, (match) => {
      const day = parseInt(match);
      const suffix = this.getOrdinalSuffix(day);
      return day + suffix;
    });
  }

  getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  getMinusIcon() {
    return `<svg aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
    </svg>`;
  }

  getPlusIcon() {
    return `<svg aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
    </svg>`;
  }

  /**
   * Show weekly menu conflict resolution step
   */
  showWeeklyMenuConflictStep(validation) {
    this.conflictValidation = validation;
    
    if (validation.action === 'selectMenu') {
      this.showWeeklyMenuSelection(validation.availableMenus);
    } else if (validation.action === 'resolveConflict') {
      this.showWeeklyMenuConflict(validation);
    }
  }

  /**
   * Show weekly menu selection UI when no menu is selected
   */
  showWeeklyMenuSelection(availableMenus) {
    const headerSubtitle = this.querySelector('.package-builder__header-subtitle');
    if (headerSubtitle) {
      headerSubtitle.textContent = 'Choose your weekly menu and delivery date';
    }

    // Filter the weekly menu dropdown to only show available menus
    this.populateAvailableWeeklyMenus(availableMenus);
  }

  /**
   * Show weekly menu conflict UI when there's a conflict with existing cart
   */
  showWeeklyMenuConflict(validation) {
    // Add conflict resolution UI
    const deliveryContent = this.querySelector('.package-builder__delivery-content');
    if (deliveryContent) {
      const conflictNotice = document.createElement('div');
      conflictNotice.className = 'package-builder__conflict-notice';
      conflictNotice.innerHTML = `
        <div class="package-builder__conflict-header">
          <p class="package-builder__conflict-description">
            It looks like you're ordering for a different week. We process every order based on each new delivery week,
            ensuring we serve all of our Stock customers on time.
          </p>

          <p class="package-builder__conflict-description">
            You can always order from our Provision store anytime you like. 
          </p>

          <p class="package-builder__conflict-description">
            Please finish stocking your fridge for your <strong class="package-builder__current-menu-title">${validation.currentMenuTitle}</strong> order.
          </p>
        </div>
        <div class="package-builder__conflict-actions">
          <button type="button" class="package-builder__clear-cart-button" data-cart-clear-button>
            Clear my cart
          </button>
          <button type="button" class="package-builder__keep-cart-button btn btn-secondary">
            Continue
          </button>
        </div>
      `;

      // Clear existing content and add conflict notice
      deliveryContent.innerHTML = '';
      deliveryContent.appendChild(conflictNotice);

      // Add event listeners for conflict resolution buttons
      const clearCartBtn = conflictNotice.querySelector('[data-cart-clear-button]');
      const keepCartBtn = conflictNotice.querySelector('.package-builder__keep-cart-button');

      clearCartBtn.addEventListener('click', () => this.handleClearCartConflict());
      keepCartBtn.addEventListener('click', () => this.close());
    }
  }

  /**
   * Handle clearing cart to resolve conflict
   */
  async handleClearCartConflict() {
    try {
      // Show loading state
      const clearCartBtn = this.querySelector('[data-cart-clear-button]');
      if (clearCartBtn) {
        clearCartBtn.textContent = 'Clearing cart...';
        clearCartBtn.disabled = true;
      }

      // Clear cart and session data
      await WeeklyMenuUtils.clearCart();
      WeeklyMenuUtils.clearSessionData();

      // Reset to normal menu selection
      const headerSubtitle = this.querySelector('.package-builder__header-subtitle');
      if (headerSubtitle) {
        headerSubtitle.textContent = 'Choose your delivery date';
      }

      // Restore normal delivery selection UI
      this.restoreNormalDeliveryUI();

      // Skip weekly menu validation for the next addToCart call
      this.skipWeeklyMenuValidation = true;

    } catch (error) {
      console.error('Error clearing cart:', error);
      // Continue anyway
      this.restoreNormalDeliveryUI();
      this.skipWeeklyMenuValidation = true;
    }
  }

  /**
   * Restore normal delivery selection UI after conflict resolution
   */
  restoreNormalDeliveryUI() {
    const deliveryContent = this.querySelector('.package-builder__delivery-content');
    if (deliveryContent) {
      // Restore original content structure
      const deliveryInfoMessage = window.themeSettings?.deliveryInfoMessage;

      deliveryContent.innerHTML = `
        <div class="package-builder__dropdown-container">
          <label for="weekly-menu-select" class="package-builder__label">Choose your delivery date</label>
          <select id="weekly-menu-select" class="package-builder__dropdown">
            <option value="">Choose a weekly menu...</option>
          </select>
        </div>

        ${deliveryInfoMessage ? `<p class="package-builder__delivery-info-note">${deliveryInfoMessage}</p>` : ''}

        <div class="package-builder__delivery-dates">
          <!-- Delivery date buttons will be populated here -->
        </div>
      `;

      // Re-setup event listener for the new dropdown
      const weeklyMenuSelect = deliveryContent.querySelector('#weekly-menu-select');
      if (weeklyMenuSelect) {
        weeklyMenuSelect.addEventListener('change', this.onWeeklyMenuChange.bind(this));
      }

      // Repopulate the weekly menus
      this.populateWeeklyMenus();
    }
  }

  /**
   * Pre-populate weekly menu selection from session data
   */
  prePopulateWeeklyMenuSelection(selectedMenu, selectedDeliveryDate) {
    // Find the menu index in the weekly menus array
    const menuIndex = this.weeklyMenus.findIndex(menu => menu.title === selectedMenu.title);
    
    if (menuIndex !== -1) {
      // Set the selected menu data
      this.packageData.weeklyMenu = selectedMenu;
      
      // Find the delivery date info
      const deliveryDateInfo = selectedMenu.delivery_dates.find(dateInfo => dateInfo.date === selectedDeliveryDate);
      if (deliveryDateInfo) {
        this.packageData.deliveryDate = deliveryDateInfo;
      }

      // Note: The actual UI pre-population will happen when populateWeeklyMenus is called
      this.prePopulatedMenuIndex = menuIndex;
      this.prePopulatedDeliveryDate = selectedDeliveryDate;
    }
  }

  /**
   * Populate only available weekly menus (used for conflict resolution)
   */
  populateAvailableWeeklyMenus(availableMenus) {
    const weeklyMenuSelect = this.querySelector('#weekly-menu-select');
    if (!weeklyMenuSelect) {
      return;
    }

    weeklyMenuSelect.innerHTML = '<option value="">Choose a weekly menu...</option>';

    availableMenus.forEach((menu, index) => {
      const option = document.createElement('option');
      option.value = index; // Use index in available menus, not original array
      option.textContent = menu.title || `Menu ${index + 1}`;
      weeklyMenuSelect.appendChild(option);
    });

    // Update the weeklyMenus reference to the filtered list for consistency
    this.filteredWeeklyMenus = availableMenus;
  }
}

customElements.define('package-builder', PackageBuilder);
